import { useState, createContext, useContext } from "react";
import { handleData } from '../api/index';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser ] = useState(null);
    const [c, setc] = useState(null);
    const [a, seta] = useState(null);
    const [s, sets] = useState(null);
    
    // const [user, setUser ] = useState(JSON.parse(localStorage.getItem('profile')));
    // const initialR = {
    //     c: false,
    //     a: false,
    //     s: false
    // }
    // const [r, setR] = useState( JSON.parse(localStorage.getItem('cas')) || initialR);

    


    const create = async(data) => {
        const result = await handleData(data);
        if(result.data.success) {
            const { _id, loginemail, gebruikersnaam, voornaam, tussenvoegsel, achternaam, info, contactemail } = result.data.data;
            setUser({
                _id,
                loginemail,
                gebruikersnaam,
                voornaam,
                tussenvoegsel,
                achternaam, 
                info,
                contactemail
            });
            return { 
                success: true
            }
        } else {
            return {
                success: false
            }
        }
    }



    const login = async(data) => {
        const result = await handleData(data);
        if(result.data.success) {
            const { _id, loginemail, gebruikersnaam, voornaam, tussenvoegsel, achternaam, info, contactemail, c, a, s } = result.data.data;
            setUser({
                _id,
                loginemail,
                gebruikersnaam,
                voornaam,
                tussenvoegsel,
                achternaam, 
                info,
                contactemail
            });
            localStorage.clear();
            if (c) {
                setc(129763);
            }
            if (a) {
                seta(157416);
            }
            if (s) {
                sets(185391);
            }


            // setR({
            //     c,
            //     a,
            //     s
            // });
            // localStorage.setItem('profile',JSON.stringify({
            //     _id: _id,
            //     loginemail: loginemail,
            //     gebruikersnaam: gebruikersnaam,
            //     voornaam: voornaam,
            //     tussenvoegsel: tussenvoegsel,
            //     achternaam: achternaam, 
            //     info: info,
            //     contactemail: contactemail
            // }));
            // localStorage.setItem('cas',JSON.stringify({
            //     c:c,
            //     a:a,
            //     s:s
            // }));
            return { 
                success: true
            }
        } else {
            return {
                success: false,
                message: result.data.message
            }
        }
    }

    const checkPassword = async(data) => {
        const result = await handleData(data);
        if (result.data.success) {
            return {
                success: true
            }
        } else {
            return {
                success: false
            }
        }
    }

    const resetpassword = async(data) => {
        const result = await handleData(data);
        if (result.data.success) {
            return {
                success: true
            }
        } else {
            return {
                success: false
            }
        }

    }

    const update = async(data) => {
        const result = await handleData(data);
        if(result.data.success) {
            const { _id, loginemail, gebruikersnaam, voornaam, tussenvoegsel, achternaam, info, contactemail } = result.data.data;
            setUser({
                _id,
                loginemail,
                gebruikersnaam,
                voornaam,
                tussenvoegsel,
                achternaam, 
                info, 
                contactemail
            });
            return { 
                success: true,
                message: result.data.message
            }
        } else {
            return {
                success: false,
                message: result.data.message
            }
        }

    }

    const logout = () => {
        setUser(null);
        setc(null);
        seta(null);
        sets(null);
        
        localStorage.clear();
    }

    

    return (
        <AuthContext.Provider value={{ 
            user,
            create, 
            login, 
            resetpassword,
            update,
            checkPassword,
            logout,
            c,
            a,
            s 
            // r
            }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => {
    return useContext(AuthContext);
}